import { createSlice } from "@reduxjs/toolkit";

const defaultFormValueRegions = {
    name: "",
    code: "",
}

const defaultFormValueProducts = {
    name: "",
    image_url: "",
    price: "",
    description: "",
}

const initialState = {
    // regions state
    showDrawerRegions: false,
    formTypeRegions: "",
    initialValuesRegions: { ...defaultFormValueRegions },
    paginationRegions: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: ""
    },
    // products state
    showDrawerProducts: false,
    formTypeProducts: "",
    initialValuesProducts: { ...defaultFormValueProducts },
    paginationProducts: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: ""
    },
};

export const mastersSlice = createSlice({
    name: "masters",
    initialState,
    reducers: {
        // regions state
        changeMastersInitialStateRegions: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerRegions = showDrawer;
            if (formType)
                state.formTypeRegions = formType;
            if (initialValues)
                state.initialValuesRegions = initialValues;
            if (!initialValues)
                state.initialValuesRegions = defaultFormValueRegions;
        },
        handlePaginationStateRegions: (state, action) => {
            const { payload } = action;
            state.paginationRegions = payload;
        },
        // products state
        changeMastersInitialStateProducts: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerProducts = showDrawer;
            if (formType)
                state.formTypeProducts = formType;
            if (initialValues)
                state.initialValuesProducts = initialValues;
            if (!initialValues)
                state.initialValuesProducts = defaultFormValueProducts;
        },
        handlePaginationStateProducts: (state, action) => {
            const { payload } = action;
            state.paginationProducts = payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    changeMastersInitialStateRegions, handlePaginationStateRegions,
    changeMastersInitialStateProducts, handlePaginationStateProducts,
} = mastersSlice.actions;

export default mastersSlice;
